var _style, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.7,13.4c-0.3-1.7-1-3.2-1.9-4.6c-1.5,0.8-3,0.9-3.8,0.1c-0.8-0.8-0.7-2.2,0.1-3.8c-1.4-0.9-2.9-1.6-4.6-1.9 C18.1,4.9,17.1,6,16,6s-2.1-1.1-2.6-2.7c-1.7,0.3-3.2,1-4.6,1.9c0.8,1.5,0.9,3,0.1,3.8S6.7,9.6,5.2,8.8c-0.9,1.4-1.6,2.9-1.9,4.6 C4.9,13.9,6,14.9,6,16s-1.1,2.1-2.7,2.6c0.3,1.7,1,3.2,1.9,4.6c1.5-0.8,3-0.9,3.8-0.1s0.7,2.2-0.1,3.8c1.4,0.9,2.9,1.6,4.6,1.9 c0.5-1.6,1.5-2.7,2.6-2.7s2.1,1.1,2.6,2.7c1.7-0.3,3.2-1,4.6-1.9c-0.8-1.5-0.9-3-0.1-3.8c0.8-0.8,2.2-0.7,3.8,0.1 c0.9-1.4,1.6-2.9,1.9-4.6C27.1,18.1,26,17.1,26,16S27.1,13.9,28.7,13.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 16,
    r: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.1ecb88a25d98564dde816ceb643b94ee.svg";
export { ForwardRef as ReactComponent };